import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Main from "./components/Main";
import "./config/firebase-config";
import * as serviceWorker from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);

serviceWorker.register();
